function toggleIframe() {
  window.toggleIframeRooster = !(window.toggleIframeRooster ?? false);
  document.querySelector(`iframe[src^="https://clock.cevesvergeer.nl/#/"]`).src = `https://clock.cevesvergeer.nl/#/${window.toggleIframeRooster ? "edit" : "iframe"}`;
  document.getElementById("js--iframe_switch").innerText = window.toggleIframeRooster ? "Terug" : "Bewerk";
}

document.addEventListener("click", event => event.target.id == "js--iframe_switch" && toggleIframe());
